module.exports = __webpack_public_path__ + "static/media/1.A & B types all Vbelts.6113ad55.jpg";